import { BuildingId } from "./building";

export const CATEGORY = {
  ALL: -21,
  POPULAR: -22,
  BUILDING: 3,
  BUILDING_ALL: -1,
  BUILDING_MENU: 31,
};

export const CATEGORY_ALIAS = {
  TALK: "talk",
  TALK_ALL: "talk-all",
  TALK_POPULAR: "talk-popular",
  TALK_FREE: "talk-free",
  TALK_SANDI_EVENT: "sandi-event",
  TALK_MARKET: "talk-market",
  TALK_TASTY: "talk-tasty",
  TALK_COMPANY: "talk-company",
  TALK_ALT: "talk-alt",

  BUILDING: "building",
  BUILDING_ALL: "building-all",
  BUILDING_MENU: "building-menu",
  BUILDING_EVENT: "building-event",
  BUILDING_NOTICE: "building-notice",
  BUILDING_MANAGER: "building-manager",
  BUILDING_FREE: "building-free",
  BUILDING_LOST: "building-lost",

  SANDI_INFO: "sandi-info",
  SANDI_FAQ: "sandi-faq",
};

export const SANDI_TALK_BLOCK_COMPANY_LIST = ["CP_0000979"];

export type StoreId = string;

export type StoreItemType = {
  name: string;
  storeId: StoreId;
};

export type SpaceId = string;
export type LifeSpaceReviewId = string;

export type BuildingStoreItem = BuildingId & {
  storeId: string;
};
